import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "lucide-react";

export default function MasterSearchField({
  onChange,
  value,
  placeholder = "Search...",
  inline = false,
}: {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;
  inline?: boolean;
}) {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      {...(value !== undefined ? { value } : {})}
      onChange={onChange}
      sx={{
        width: inline ? 220 : undefined,
        minWidth: inline ? 180 : { xs: "100%", sm: 220 },
        flex: inline ? "0 0 auto" : undefined,
        bgcolor: "white",
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search size={16} color="#5A5D76" />
          </InputAdornment>
        ),
      }}
    />
  );
}
